import React from 'react';
import {AssetTypeFormProps} from '../interfaces';
import {
  AssetSizeSelect,
  TrailerNumberField,
  SealNumberField,
  DriverFields,
  ScacCodeField,
  TruckLicensePlateField,
  NotesField,
} from '../fields';

/**
 * Check-in form for Trailer Loaded asset types.
 * Covers: TRUCK_TRAILER_LOADED, TRAILER_LOADED, REEFER_LOADED_PLUGIN,
 *         REEFER_LOADED_NO_PLUGIN, TRUCK_REEFER_LOADED_PLUGIN, TRUCK_REEFER_LOADED_NO_PLUGIN.
 *
 * Required fields: Trailer Number, Seal Number, Driver License Number,
 *                  Driver First Name, Driver Last Name.
 * Optional fields: Asset Size (rendered but not required).
 */
const TrailerLoadedForm: React.FC<AssetTypeFormProps> = ({form, errors, onValueChange, onAssetSizeChange}) => {
  return (
    <>
      <AssetSizeSelect
        value={form.assetSize}
        onChange={onAssetSizeChange}
      />
      <TrailerNumberField
        value={form.trailerNumber}
        onValueChange={onValueChange}
        error={errors.trailerNumber}
        required
      />
      <SealNumberField
        value={form.sealNumber}
        onValueChange={onValueChange}
        error={errors.sealNumber}
        required
      />
      <DriverFields
        form={form}
        errors={errors}
        onValueChange={onValueChange}
        requireLicense
      />
      <ScacCodeField
        value={form.scacCode}
        onValueChange={onValueChange}
        error={errors.scacCode}
      />
      <TruckLicensePlateField
        value={form.truckLicensePlateNumber}
        onValueChange={onValueChange}
        error={errors.truckLicensePlateNumber}
      />
      <NotesField
        value={form.notes}
        onValueChange={onValueChange}
      />
    </>
  );
};

export default TrailerLoadedForm;

